import React from "react";
import TXT from "presentational/common/multinational/TXT";
import CommonGuideTooltipView from "presentational/common/modals/CommonGuideTooltipView";
import PropTypes from "prop-types";
import config from "lib/fr-config";

const cookieNameIndex = config.cookieNameIndex;

ItemDetailGuideTooltipView.propTypes = {
  disabled: PropTypes.bool,
  hasClickedAtLeastOnce: PropTypes.bool.isRequired
};

ItemDetailGuideTooltipView.defaultProps = {
  disabled: false
};

function ItemDetailGuideTooltipView(props) {
  const { disabled, hasClickedAtLeastOnce, children } = props;

  return (
    <CommonGuideTooltipView
      needClose={disabled || hasClickedAtLeastOnce}
      needCountUp={!disabled && hasClickedAtLeastOnce}
      message={<TXT name="msg_tooltipClickItemTagsOfItemDetail" />}
      placement={"top"}
      arrow
      backgroundDesign={"primary"}
      displayOnModal
      displayForGuest
      cookieName={cookieNameIndex.itemDetailGuide.name}
      maxDisplayCount={cookieNameIndex.itemDetailGuide.count}
    >
      {children}
    </CommonGuideTooltipView>
  );
}

export default ItemDetailGuideTooltipView;
